
import { mapState } from "vuex";
import format from "timestamp-format";
import Datetime from 'vux/src/components/datetime/index.vue'

import { updateBirthDay } from "@/common/api/bindAuthenticate";


import MyBasePage from "../../../components/MyBasePage";
import IconTriangle from "../../components/IconTriangle";

import IconUser from "./components/IconUser";
import IconName from "./components/IconName";
import IconPhone from "./components/IconPhone";
import IconEmail from "./components/IconEmail";
import IconBirthday from "./components/IconBirthday";
import IconPassword from "./components/IconPassword";
import IconCashoutPassword from "./components/IconCashoutPassword";
import IconVip from "./components/IconVip.vue";

export default {
data() {
return {
submitting: false,
tempBirthday: "",
birthdaySetting: false,
telegram_credential: window.telegram_credential,
};
},
components: {
MyBasePage,
Datetime,
IconTriangle,

IconUser,
IconName,
IconPhone,
IconEmail,
IconBirthday,
IconPassword,
IconCashoutPassword,
IconVip,
},
inject: ["parentRoot"],
computed: {
...mapState({
userInfo: (state) => state.userInfo.userInfo,
level: (state) => (state.userInfo.vipInfo.vipLevel || 0) + 1,
birthday() {
if (this.userInfo.birthday) {
return format("yyyy-MM-dd", this.userInfo.birthday);
}
return null;
},
birthdayLimit() {
const start = new Date();
start.setFullYear(start.getFullYear() - 80);

const end = new Date();
end.setFullYear(end.getFullYear() - 18);

return {
start: format("yyyy-MM-dd", start),
end: format("yyyy-MM-dd", end),
};
},
}),
},
methods: {
async handleBirthdaySet(date) {
try {

this.$store.commit("updateLoadingStatus", { isLoading: true });

await updateBirthDay({ date });

await this.$store.dispatch("getFirstInfo");
} catch (msg) {
this.$vux.toast.show({
text: "生日设置成功",
type: "success",
});
} finally {

this.$store.commit("updateLoadingStatus", { isLoading: false });
}
},
async handleSignout() {
if (this.submitting) {
return;
}

try {
this.submitting = true;

await this.$store.dispatch("Logout");

this.$vux.toast.show({
text: this.$t("mine").accountManage.loiginOut,
type: "success",
});




} catch (msg) {
this.$vux.toast.show({
text: msg,
type: "cancel",
});
} finally {
this.submitting = false;
}
},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/AccountManat/AccountInfo/index.vue